import React, { useState, useEffect, memo } from "react";
import { useAsyncDebounce } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import { DebounceInput } from "react-debounce-input";
import AutoComplete from "react-autocomplete";
import Skeleton from "react-loading-skeleton";
import { DeleteLocalStorageSearch } from "../../function";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// CONTEXT
import { SearchBarContext } from "../../context/SearchBarContext";

// FONTAWESOME
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

const AutoCompleteMemo = memo(() => {
  return;
});

function SearchBar() {
  const dispatch = useDispatch();
  const searchBar = useSelector((state) => state.searchBar);

  const [optionsSearch, setOptionsSearch] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const listSearch = localStorage.getItem("listSearch");

    if (listSearch) {
      setOptionsSearch(JSON.parse(listSearch));
    }
    setLoading(false);
  }, [localStorage, searchBar.value]);

  const onChange = (e) => {
    dispatch(onChangeSearchBar(e.target.value));
  };

  const onDeleteInput = (e) => {
    e.stopPropagation();
    dispatch(onChangeSearchBar(""));
  };

  const onChangeSelect = (value) => {
    dispatch(onChangeSearchBar(value));
  };

  const onDeleteSearch = (value, e) => {
    e.stopPropagation();
    const filterSearch = DeleteLocalStorageSearch(value);
    setOptionsSearch(filterSearch);
  };

  return (
    <form className=" w-full ">
      <div className="relative ml-4 flex w-full flex-wrap  items-center py-0">
        <span className="w-10 z-10 h-8 py-1 leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center   ">
          <FontAwesomeIcon icon={faSearch} />
        </span>
        {loading ? (
          <Skeleton />
        ) : (
          <AutoComplete
            // minLength={1}
            // debounceTimeout={1200}
            // value={searchBar.value}
            // onChange={onChange}
            getItemValue={(item) => item.label}
            items={optionsSearch}
            renderItem={(item, isHighlighted) => {
              return (
                <div
                  className={classNames(
                    "py-2 hover:bg-blue-500 shadow bg-white px-3 flex justify-between items-center duration-300 transition-all rounded",
                    {}
                  )}
                >
                  <div> {item.label}</div>
                  <button
                    type="button"
                    onClick={(e) => onDeleteSearch(item.label, e)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-red-500 cursor-pointer"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              );
            }}
            renderMenu={(items, value, style) => {
              if (items.length > 0) {
                return (
                  <div
                    className="absolute top-full w-full mt-2"
                    children={items}
                  />
                );
              }
              return <div></div>;
            }}
            value={searchBar.value}
            onChange={(e) => onChange(e)}
            onSelect={(val) => onChangeSelect(val)}
            type="text"
            placeholder="ค้นหา ..."
            renderInput={(props) => {
              return (
                <div className="relative w-full">
                  <input
                    className=" flex items-center  border-0 px-3 py-2 w-full placeholder-blueGray-400 text-blueGray-600 relative bg-white rounded text-base shadow outline-none focus:outline-none focus:ring pl-10"
                    {...props}
                  />
                  {searchBar.value && (
                    <button
                      onClick={onDeleteInput}
                      className="w-10 z-10 h-8 py-1 -right-2 top-1 leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center   "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-red-500 cursor-pointer"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              );
            }}
          />
        )}
      </div>
    </form>
  );
}

export default SearchBar;
